import React from 'react';
import { ArrowRight, ShieldCheck } from 'lucide-react';
import { CALENDAR_LINK } from './Header';
export function Hero() {
  return <section className="relative pt-32 pb-20 lg:pt-48 lg:pb-32 overflow-hidden bg-brand-navy" data-id="element-87">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-88">
        <img src="https://images.unsplash.com/photo-1511895426328-dc8714191300?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80" alt="Familia feliz reunida disfrutando del tiempo juntos" className="w-full h-full object-cover opacity-30" data-id="element-89" />
        <div className="absolute inset-0 bg-gradient-to-r from-brand-navy via-brand-navy/90 to-transparent" data-id="element-90"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-91">
        <div className="max-w-2xl" data-id="element-92">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-brand-green/20 border border-brand-green/30 text-brand-green text-sm font-medium mb-6" data-id="element-93">
            <ShieldCheck className="w-4 h-4" data-id="element-94" />
            <span data-id="element-95">Protección y Ahorro Inteligente</span>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6" data-id="element-96">
            El método financiero que nunca te enseñaron. Haz que tu dinero
            trabaje para ti y construye el{' '}
            <span className="text-brand-green" data-id="element-97">
              legado que tu familia merece
            </span>
            .
          </h1>

          <p className="text-lg md:text-xl text-gray-300 mb-8 leading-relaxed" data-id="element-98">
            Descubre cómo el IUL (Seguro de Vida Universal Indexado) te permite
            proteger a los que más amas mientras creas un fondo de retiro libre
            de impuestos.
          </p>

          <div className="flex flex-col sm:flex-row gap-4" data-id="element-99">
            <a href={CALENDAR_LINK} target="_blank" rel="noopener noreferrer" className="inline-flex justify-center items-center gap-2 bg-brand-green hover:bg-green-700 text-white px-8 py-4 rounded-md font-bold text-lg transition-all shadow-lg hover:shadow-xl hover:-translate-y-0.5" data-id="element-100">
              Agenda tu Consulta Gratis
              <ArrowRight className="w-5 h-5" data-id="element-101" />
            </a>
            <a href="#beneficios" className="inline-flex justify-center items-center gap-2 bg-white/10 hover:bg-white/20 text-white px-8 py-4 rounded-md font-semibold text-lg transition-all backdrop-blur-sm" data-id="element-102">
              Conoce más
            </a>
          </div>

          <div className="mt-10 flex items-center gap-4 text-sm text-gray-400" data-id="element-103">
            <div className="flex -space-x-2" data-id="element-104">
              {[1, 2, 3, 4].map(i => <img key={i} className="w-8 h-8 rounded-full border-2 border-brand-navy" src={`https://i.pravatar.cc/100?img=${i + 10}`} alt="Cliente feliz" data-id="element-105" />)}
            </div>
            <p data-id="element-106">Únete a cientos de familias protegidas</p>
          </div>
        </div>
      </div>
    </section>;
}